<!--
    描述：专家通审核
    日期：2022/9/19
    创建人：李家宝
-->
<template>
	<div class="box">
		<!--开标时间提醒-->
		<div v-if="audit === 'audit'">
			<div class="tips-warning" v-if="isShowTime1">
				<i style="font-size: 20px;color: #F4650F;margin-right: 5px" class="el-icon-warning"></i>
				<span>距离{{ isReEvaluate ? '开标' : '评审' }}时间仅剩{{ hour }}小时{{ minute }}分钟，请尽快完成审核！</span>
			</div>
			<div class="tips-warning" v-if="isShowTime2">
				<i style="font-size: 20px;color: #F4650F;margin-right: 5px" class="el-icon-warning"></i>
				<span
					>距离{{ isReEvaluate ? '开标' : '评审' }}时间已超出{{ hour }}小时{{ minute }}分{{
						second
					}}秒，若超过2小时后无法进行审核，请尽快完成审核！</span
				>
			</div>
			<div class="tips-error" v-if="isShowTime3">
				<i style="font-size: 20px;color: red;margin-right: 5px" class="el-icon-warning"></i>
				<span>已超过{{ isReEvaluate ? '开标' : '评审' }}时间2小时，本条申请记录已过期，只能当作驳回处理！</span>
			</div>
		</div>
		<el-collapse v-model="activeNames">
			<el-collapse-item title="项 目 登 记" name="1">
				<el-form label-width="150px" :show-message="false">
					<!--专家库使用单位信息-->
					<div class="zjxq_box">
						<div class="box_text">专家库使用单位信息</div>
						<el-row>
							<el-col :span="12">
								<el-form-item label="使用单位名称：">{{ busProjectObj.tenantName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="社会统一信用代码：">{{ busProjectObj.creditCode }} </el-form-item>
							</el-col>
							<!--<el-col :span="12" v-if="isReEvaluate">-->
							<!--  <el-form-item label="操作人姓名："-->
							<!--    >{{ busProjectDetailsObj.operator }}-->
							<!--  </el-form-item>-->
							<!--</el-col>-->
							<!--<el-col :span="12" v-if="isReEvaluate">-->
							<!--  <el-form-item label="操作人联系电话："-->
							<!--    >{{ busProjectDetailsObj.operatorPhone }}-->
							<!--  </el-form-item>-->
							<!--</el-col>-->
							<el-col :span="12">
								<el-form-item label="联系人：">{{ busProjectObj.contacter }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="联系电话：">{{ busProjectObj.contacterPhone }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="单位类型：">
									{{ busProjectObj.flatTypeName }}
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<!--项目信息-->
					<div class="zjxq_box">
						<div class="box_text" style="border-bottom: 0px">项目信息</div>
						<el-row>
							<el-col :span="24">
								<el-form-item label="项目名称：">{{ msgProject.sname }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目类型：">
									<!--{{-->
									<!--  isReEvaluate-->
									<!--    ? msgProject.busTypeName-->
									<!--    : msgProject.proTypeName-->
									<!--}}-->
									{{ msgProject.proTypeName }}
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="预算金额："
									>{{ busProjectDetailsObj.budget }}万元
									<!--{{ isReEvaluate ? "元" : "万元" }}-->
								</el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="资金来源：">
									{{ busProjectDetailsObj.fondSourceName }}
								</el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="交易方式：">{{ busProjectDetailsObj.dealTypeName }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="交易组织方式：">{{ busProjectDetailsObj.organizeTypeName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目所在区域：">{{ busProjectDetailsObj.proAreaName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目详细地址：">{{ busProjectDetailsObj.proAddress }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="公告发布时间：">{{ busProjectDetailsObj.publishTime }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="公告发布原文：">{{ busProjectDetailsObj.noticeUrl }} </el-form-item>
							</el-col>
							<el-col :span="24" v-if="!isReEvaluate">
								<el-form-item label="项目附件：">
									<div class="beyondHiding">
										<div
											v-for="(item, index) in projectFilePss"
											:key="index"
											class="link mr10"
											type="text"
											@click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
										>
											<span slot="reference">{{ item.fileName }}</span>
											<!--                      <el-popover
                          placement="top-start"
                          title="文件"
                          trigger="hover"
                      >
                        <div
                            v-for="e in projectFilePss"
                            class="link"
                            :key="e.id"
                            @click="viewFile(e.fullFilePath)"
                        >
                          {{ e.fileName }}
                        </div>
                        <span slot="reference">{{ item.fileName }}</span>
                      </el-popover>-->
										</div>
									</div>
									<!--                  <public-upload
                    ref="cns"
                    :aid="baseProject.id"
                    :maxNum="1"
                    assortment="bus_project_ps"
                    :tableName="'business_expand_zhuanjia'"
                    mode="view"
                    forDatabase="project_audit"
                    :isDisabled="true"
                  />-->
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<!--标段信息-->
					<div class="zjxq_box">
						<div class="box_text">{{ typeText }}信息</div>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="typeText + '地点：'">{{ busProjectObj.areaName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="typeText + '详细地址：'">{{ busProjectObj.bidAddress }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="typeText + '时间：'"
									>{{ msgProject.openTime }}
									<span style="color: red" v-if="isShowTime1 && audit === 'audit'"
										>（还剩{{ hour }}小时{{ minute }}分钟{{ second }}秒）</span
									>
								</el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="评标开始时间：">{{ busProjectObj.startTime }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="预估评标时长：">{{ busProjectObj.estimateTimes }}小时 </el-form-item>
							</el-col>
							<el-col :span="12" v-if="!isReEvaluate">
								<el-form-item label="评审类型：">{{ busProjectObj.reviewTypeName }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="!isReEvaluate">
								<el-form-item label="计划抽取人数：">{{ msgProject.extractNum }}人 </el-form-item>
							</el-col>
							<el-col :span="24" v-if="isReEvaluate">
								<el-table class="mt10" highlight-current-row row-key="id" border ref="table" :data="busProjectBidObj">
									<el-table-column type="index" label="序号" align="center" width="100" show-overflow-tooltip></el-table-column>
									<el-table-column prop="sname" label="标段名称" min-width="180" show-overflow-tooltip> </el-table-column>
									<el-table-column prop="codeName" label="标段分类代码" min-width="180" align="center" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="bidTypeName" label="标段类型" min-width="180" align="center" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="budget" label="预算金额" min-width="180" align="center" show-overflow-tooltip>
										<template slot-scope="scope">
											{{ scope.row.budget }}万元
											<!--{{ isReEvaluate ? "元" : "万元" }}-->
										</template>
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
					</div>
					<!--建设单位信息-->
					<div class="zjxq_box">
						<div class="box_text">建设单位信息</div>
						<el-row>
							<el-col :span="12">
								<el-form-item label="建设单位名称：">{{ busProjectDetailsObj.consUnit }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="社会统一信用代码：">{{ busProjectDetailsObj.consCode }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="负责人姓名：" v-if="isReEvaluate">{{ busProjectDetailsObj.principal }} </el-form-item>
								<el-form-item label="项目负责人：" v-else>{{ busProjectDetailsObj.consPrincipal }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="负责人联系电话：" v-if="isReEvaluate">{{ busProjectDetailsObj.principalPhone }} </el-form-item>
								<el-form-item label="联系电话：" v-else>{{ busProjectDetailsObj.consPhone }} </el-form-item>
							</el-col>
							<el-col :span="12" v-if="isReEvaluate">
								<el-form-item label="单位类型：">{{ busProjectDetailsObj.consUnitTypeName }} </el-form-item>
							</el-col>
							<el-col :span="17" v-if="!isReEvaluate">
								<el-form-item label="备注：">{{ busProjectDetailsObj.consRemark }} </el-form-item>
							</el-col>
							<el-col :span="24" v-if="isReEvaluate">
								<el-form-item label="项目附件：">
									<div class="beyondHiding">
										<div
											v-for="(item, index) in projectFiles"
											:key="index"
											class="link mr10"
											type="text"
											@click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
										>
											<span slot="reference">{{ item.fileName }}</span>
											<!--                      <el-popover
                          placement="top-start"
                          title="文件"
                          trigger="hover"
                      >
                        <div
                            v-for="e in projectFiles"
                            class="link"
                            :key="e.id"
                            @click="viewFile(e.fileDirectory + e.serverName)"
                        >
                          {{ e.fileName }}
                        </div>
                        <span slot="reference">{{ item.fileName }}</span>
                      </el-popover>-->
										</div>
									</div>
									<!--                  <public-upload
                    ref="cns"
                    :aid="baseProject.id"
                    :maxNum="1"
                    assortment="bus_project"
                    :tableName="'business_expand_zhuanjia'"
                    mode="view"
                    forDatabase="project_audit"
                    :isDisabled="true"
                  />-->
								</el-form-item>
							</el-col>
						</el-row>
					</div>
					<!--  设计单位信息-->
					<div class="zjxq_box" v-if="!isReEvaluate">
						<div class="box_text">设计单位信息</div>
						<el-row>
							<el-col :span="12">
								<el-form-item label="设计单位名称：">{{ busProjectDetailsObj.designUnit }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="社会统一信用代码：">{{ busProjectDetailsObj.designCode }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="项目负责人：">{{ busProjectDetailsObj.designPrincipal }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="联系电话：">{{ busProjectDetailsObj.designPhone }} </el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="备注：">{{ busProjectDetailsObj.designRemark }} </el-form-item>
							</el-col>
						</el-row>
					</div>
				</el-form>
				<div>
					<img src="../../../assets/images/rejected.png" alt="驳回" title="驳回" class="img" v-if="baseProject.isVerify == 3" />

					<img
						src="../../../assets/images/examinationpassed.png"
						v-if="baseProject.isVerify == 2"
						alt="审核通过"
						title="审核通过"
						class="img"
					/>
				</div>
			</el-collapse-item>
		</el-collapse>
		<!--专家需求-->
		<el-collapse v-model="activeNames">
			<el-collapse-item :title="isReEvaluate ? '专 家 需 求' : '规 避 信 息'" name="2">
				<!--规避单位-->
				<div class="zjxq_box">
					<div class="box_text">规避单位</div>
					<el-table class="mt10" highlight-current-row row-key="id" border ref="table" :data="evadeUnitsArr">
						<el-table-column type="index" label="序号" align="center" width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="sname" label="单位名称" show-overflow-tooltip> </el-table-column>
					</el-table>
				</div>
				<!--规避专家-->
				<div class="zjxq_box">
					<div class="box_text">规避专家</div>
					<el-table class="mt10" highlight-current-row row-key="id" border ref="table" :data="evadeExpertsArr">
						<el-table-column type="index" label="序号" align="center" width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="sname" align="center" label="专家姓名" show-overflow-tooltip> </el-table-column>
						<el-table-column prop="phone" align="center" label="手机号" show-overflow-tooltip> </el-table-column>
						<!--<el-table-column-->
						<!--  prop="unitName"-->
						<!--  align="center"-->
						<!--  label="公司"-->
						<!--  show-overflow-tooltip-->
						<!--&gt;-->
						<!--</el-table-column>-->
					</el-table>
				</div>
				<!--抽取规则设置-->
				<div class="zjxq_box" v-if="isReEvaluate">
					<div class="box_text">
						抽取规则设置
						<el-button type="primary" class="ml10" size="mini" @click="viewRule">查看详情 </el-button>
					</div>
					<el-table class="mt10" highlight-current-row row-key="id" border ref="table" :data="extractDetailObj">
						<el-table-column type="index" label="序号" align="center" width="80" show-overflow-tooltip></el-table-column>
						<el-table-column prop="libName" label="抽取专家库" align="center" min-width="180" show-overflow-tooltip> </el-table-column>
						<el-table-column prop="speName" label="评标专业" align="center" min-width="180" show-overflow-tooltip> </el-table-column>
						<el-table-column prop="altName" label="候补专业" align="center" min-width="180" show-overflow-tooltip> </el-table-column>
						<el-table-column prop="persons" label="所需人数" align="center" min-width="180" show-overflow-tooltip>
							<template slot-scope="scope"> {{ scope.row.persons }}人</template>
						</el-table-column>
						<el-table-column prop="locationName" label="专家所在地区" align="center" min-width="180" show-overflow-tooltip>
						</el-table-column>
					</el-table>
				</div>
				<el-row class="zjxq_box">
					<el-col :span="17" v-if="isReEvaluate">
						<span style="color: red">*</span>
						<span>抽取专家方式：</span>
						<span class="zjxq_box_item"
							>{{ busProjectObj.extractType == 0 ? '手动抽取' : '系统定时抽取' }} {{ busProjectObj.timingDate }}</span
						>
						<span class="ml20">开标时间：</span>
						<span>{{ this.msgProject.openTime }}</span>
						<span style="color: red">（注：开标前24小时内方可进行专家抽取）</span>
					</el-col>
					<el-col :span="6">
						<span style="color: red">*</span>
						<span>专家费用支付方式：{{ busProjectObj.payType == 0 ? '线下支付 ' : '线上支付' }}</span>
					</el-col>
				</el-row>
			</el-collapse-item>
		</el-collapse>
		<!--项目复评-->
		<el-collapse v-model="activeNames" v-if="msgProject.projectReviewObj != null">
			<el-collapse-item title="项 目 复 评" name="3">
				<el-form label-width="150px" :show-message="false">
					<!--专家库使用单位信息-->
					<div class="zjxq_box">
						<el-row>
							<el-col :span="24">
								<el-form-item label="复评原因：">
									{{ JSON.parse(msgProject.projectReviewObj).judgeReason }}
								</el-form-item>
							</el-col>
						</el-row>
					</div>
				</el-form>
			</el-collapse-item>
		</el-collapse>
		<!--审核按钮-->
		<div class="footer text-right">
			<el-button size="mini" v-if="audit === 'audit'" @click="auditSubmit" icon="el-icon-edit-outline">审核 </el-button>
		</div>
		<!-- 驳回审核弹框 -->
		<el-dialog :visible.sync="auditShow" width="600px" center title="审核" :close-on-click-modal="false" @close="closeDialog">
			<div style="text-align: center;padding-bottom: 20px;">
				当前已过开标时间，本条申请记录已过期，只能作为驳回处理，确认本次操作！
			</div>
			<div style="text-align: center">
				<el-button class="btn cancel-btn" size="small" @click="closeDialog">取消 </el-button>
				<el-button class="btn btn-blue" type="primary" size="small" :loading="btnLoading" @click="submitCheck">提交 </el-button>
			</div>
		</el-dialog>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width" :close-on-click-modal="false" center>
			<el-form label-width="108px">
				<div class="zjxq_box">
					<div class="box_text">语音通知内容设置</div>
					<el-row>
						<el-col :span="12">
							<el-form-item label="集合时间：" required>{{ busProjectObj.gatherTime }} </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="集合地点：" required>{{ busProjectObj.areaName }} </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="详细地址：" required>{{ busProjectObj.gatherAddress }} </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label-width="128px" label="预估评标时长：" required>{{ busProjectObj.estimateTimes }}小时 </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系人：" required>{{ busProjectDetailsObj.extContacter }} </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="联系电话：" required>{{ busProjectDetailsObj.extContacterPhone }} </el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label-width="128px" label="计划抽取人数：" required>{{ msgProject.extractNum }}人 </el-form-item>
						</el-col>
					</el-row>
				</div>
				<div class="zjxq_box">
					<div class="box_text">抽取条件填写</div>
					<div class="box_item mb20" v-for="(item, index) in extractDetailObj" :key="index">
						<el-row>
							<el-col :span="8">
								<el-form-item label="所需人数：" required>{{ item.persons }}人 </el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="抽取专家库：">{{ item.libName }} </el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="评标区域：">{{ item.reviewName }} </el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="选择专家归属地：" label-width="135px" required>{{ item.locationName }} </el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="评标专业：" required>{{ item.speName }} </el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="候补专业：">{{ item.altName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="职称：">{{ item.certificate }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="职称专业：">{{ item.qualified }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="执业资格：">{{ item.typeName }} </el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="执业资格专业：" label-width="128px">{{ item.professionName }} </el-form-item>
							</el-col>
						</el-row>
					</div>
				</div>
			</el-form>
		</el-dialog>
		<!--操作记录-->
		<div class="pdl10 pdr10" v-if="audit === 'view'">
			<h3>操作记录：</h3>
			<el-table :data="checkData" class="mt15" height="200px" highlight-current-row row-key="id" border ref="table">
				<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
				<el-table-column label="操作人" align="center" width="250" prop="createUserName"></el-table-column>
				<el-table-column label="操作时间" align="center" width="250" prop="createDate">
					<template slot-scope="scope">
						<span>{{ scope.row.createDate ? scope.row.createDate.substring(0, 16) : '' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作步骤" align="center" width="250" prop="currentSteps"></el-table-column>
				<el-table-column label="结果" header-align="center" prop="content"> </el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { getProjectAuditLog, getProjectMsgByIdForZhuanjia } from 'api/modules/projectManagement'
import { auditProjectForJuyi } from '../../../api/modules/projectManagement'
import VUE_CONFIG from '../../../../vue.config'

export default {
	name: 'zhuanjia-project-audit',
	props: {
		// 数据
		rowData: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 是否编辑
		audit: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			activeNames: ['1', '2', '3'],
			auditShow: false, // 审核弹窗的显隐
			btnLoading: false, // 提交按钮状态
			isShowTime1: false, // 开标时间前24小时提醒
			isShowTime2: false, // 开标时间已过2小时提醒
			isShowTime3: false, // 开标时间超出2小时提醒
			hour: null, // 时
			minute: null, // 分
			second: null, // 秒
			timer: null, // 定时器
			checkData: [], //操作记录
			baseProject: {},
			busProjectObj: {}, // 项目基本信息
			msgProject: {},
			busProjectDetailsObj: {}, //项目明细
			busProjectBidObj: [], // 标段信息
			evadeUnitsArr: [], // 规避单位
			evadeExpertsArr: [], // 规避专家
			extractDetailObj: [], // 抽取规则
			projectFiles: [],
			projectFilePss: [],
			dialogObj: {
				title: '抽取规则',
				visible: false,
				width: '60%',
				mode: 'add'
			},
			typeText: '评标' // 评审和评标的文字
		}
	},
	computed: {
		// 判断是评标还是评审
		isReEvaluate() {
			let busType = this.msgProject.busType == '1009007002'
			this.typeText = busType ? '评审' : '评标'
			return !busType
		}
	},
	methods: {
		// open 审查弹框
		openDia(data) {
			this.$emit('openDia', data)
		},

		//查询审核记录
		getProjectAuditLog() {
			getProjectAuditLog({
				baseId: this.rowData.id
			}).then((res) => {
				if (res.operationCode == '1') {
					this.checkData = res.data
				}
			})
		},

		// 详情
		getProjectMsgByIdForZhuanjia() {
			getProjectMsgByIdForZhuanjia({
				id: this.rowData.id
			}).then((res) => {
				if (res.operationCode == 1) {
					this.msgProject = res.data.project
					this.busProjectObj = res.data.project.busProjectObj
					this.busProjectDetailsObj = res.data.project.busProjectDetailsObj
					this.busProjectBidObj = res.data.project.busProjectBidObj
					this.evadeUnitsArr = res.data.project.evadeUnitsArr
					this.evadeExpertsArr = res.data.project.evadeExpertsArr
					this.extractDetailObj = res.data.project.extractDetailObj
					this.baseProject = res.data.msgProject
					this.projectFiles = res.data.project.sysFiles
						? JSON.parse(res.data.project.sysFiles).filter((v) => v.assortment == 'bus_project')
						: []
					this.projectFilePss = res.data.project.sysFiles
						? JSON.parse(res.data.project.sysFiles).filter((v) => v.assortment == 'bus_project_ps')
						: []
				}
			})
		},

		// 审核
		auditSubmit() {
			let params = {
				id: this.baseProject.id,
				isReject: this.isShowTime3
			}
			if (this.isShowTime3) {
				this.auditShow = true
			} else {
				this.$emit('openDia', params)
			}
		},

		// 审核驳回
		submitCheck() {
			this.btnLoading = true
			let params = {
				content: `当前已过${this.isReEvaluate ? '开标' : '评审'}时间，本条申请记录已过期，只能作为驳回处理。`,
				id: this.baseProject.id,
				isVerify: '3',
				projectLevel: '',
				updateUserid: ''
			}
			auditProjectForJuyi(params).then((res) => {
				if (res.code == 0) {
					if (res.operationCode == 1) {
						this.baseProject.isVerify == 2 ? this.$message.success('审核成功') : this.$message.success('已驳回')
					} else {
						this.$message.error(res.msg)
					}
					this.auditShow = false
					this.btnLoading = false
					this.$router.push({ path: 'to-audit-proJect-list' })
				}
			})
		},

		// 计算时间区间
		timeInterval(dateTime) {
			// 指定日期和时间
			let EndTime = new Date(dateTime)
			// 当前系统时间
			let NowTime = new Date()
			let t = EndTime.getTime() - NowTime.getTime()
			let hValue = t / (1000 * 60 * 60) // 小时
			return hValue
		},

		// 获取距离指定时间
		getDistanceSpecifiedTime(dateTime) {
			// 指定日期和时间
			let EndTime = new Date(dateTime)
			// 当前系统时间
			let NowTime = new Date()
			let t = EndTime.getTime() - NowTime.getTime()
			this.hour = Math.floor((t / 1000 / 60 / 60) % 24)
			this.minute = Math.floor((t / 1000 / 60) % 60)
			this.second = Math.floor((t / 1000) % 60)
		},

		// 获取距离指定时间过去多长时间
		getDistanceSpecifiedGQTime(dateTime) {
			// 指定日期和时间
			let EndTime = new Date(dateTime)
			// 当前系统时间
			let NowTime = new Date()
			let t = NowTime.getTime() - EndTime.getTime()
			this.hour = Math.floor((t / 1000 / 60 / 60) % 24)
			this.minute = Math.floor((t / 1000 / 60) % 60)
			this.second = Math.floor((t / 1000) % 60)
		},

		// 查看
		viewRule(row) {
			this.dialogObj.visible = true
		},

		// 获取时间
		getDate() {
			this.timer = setInterval(() => {
				let currentDate = this.timeInterval(this.msgProject.openTime)
				// 距离开标时间前 24 小时
				if (currentDate <= 24 && currentDate >= 0) {
					this.isShowTime1 = true
					this.getDistanceSpecifiedTime(this.msgProject.openTime)
				} else if (currentDate <= 0 && currentDate >= -2) {
					// 开标时间后两个小时
					this.isShowTime1 = false
					this.isShowTime2 = true
					this.getDistanceSpecifiedGQTime(this.msgProject.openTime)
				} else if (currentDate < -2) {
					// 开标时间已过两个小时
					this.isShowTime2 = false
					this.isShowTime3 = true
					clearInterval(this.timer)
					this.timer = null
				}
			})
		},
		// close 审查弹框
		closeDialog() {
			this.auditShow = false
		},

		// 查看文件
		viewFile(filePath, fileName) {
			let uploadUrl = ''
			if (process.env.VUE_APP_UPLOAD_URL == '/uploadApi') {
				uploadUrl = VUE_CONFIG.devServer.proxy['/uploadApi'].target
			} else {
				uploadUrl = process.env.VUE_APP_UPLOAD_URL
			}
			this.$previewFn(uploadUrl + filePath, fileName)
		}
	},
	beforeDestroy() {
		// 清除定时器
		clearInterval(this.timer)
		this.timer = null
	},

	created() {
		if (!this.rowData.id) {
			this.$router.push({
				name: 'to-audit-proJect-list'
			})
			return
		}
		if (this.audit === 'view') {
			//操作记录
			this.getProjectAuditLog()
		}
		this.getDate()
		this.getProjectMsgByIdForZhuanjia()
	}
}
</script>

<style scoped lang="less">
/deep/ .el-collapse-item__header {
	background: #eff6fe;
	font-weight: bolder;
	padding-left: 10px;
}

.box {
	position: relative;
	height: 100%;

	.tips-warning,
	.tips-error {
		color: #f4650f;
		display: flex;
		align-items: center;
		position: absolute;
		top: 14px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 99;
	}

	.tips-error {
		color: red;
	}

	.footer {
		position: fixed;
		top: 88px;
		right: 135px;

		.el-button {
			height: 28px !important;
		}
	}

	.img {
		position: absolute;
		width: 118px;
		height: 90px;
		top: 256px;
		right: 187px;
	}
}

.zjxq_box {
	padding: 10px 20px;
	margin-bottom: 10px;

	.box_text {
		font-weight: 500;
		border-bottom: 1px solid #f5f5f5;
		height: 30px;

		&:before {
			content: '';
			width: 3px;
			margin-right: 5px;
			height: 12px;
			background: #1f79ff;
			display: inline-block;
			vertical-align: central;
		}
	}

	.zjxq_box_item {
		display: inline-block;
		width: 300px;
		height: 40px;
		line-height: 40px;
		background: #f2f2f2;
		padding: 0 5px;
	}

	.el-form-item {
		margin-bottom: 0;
	}

	.box_item {
		width: 100%;
		background: #f8f8f8;
		padding: 15px 25px;
	}
}
</style>
